import * as GC from '@grapecity/spread-sheets';

export const suspendAll = (sheet: GC.Spread.Sheets.Worksheet) => {
  if (sheet && !sheet.isPaintSuspended()) {
    sheet.suspendPaint();
    sheet.suspendEvent();
  }
};
export const resumeAll = (sheet: GC.Spread.Sheets.Worksheet) => {
  if (sheet && sheet.isPaintSuspended()) {
    sheet.resumeEvent();
    sheet.resumePaint();
  }
};

export const suspendDoAndResume = async (sheet: GC.Spread.Sheets.Worksheet, taskToPerform: CallableFunction) => {
  if (sheet) {
    try {
      const wasSuspended = sheet.isPaintSuspended();
      if (!wasSuspended) {
        sheet.suspendPaint();
        sheet.suspendEvent();
      }

      await Promise.resolve(taskToPerform());

      if (!wasSuspended) {
        sheet.resumeEvent();
        sheet.resumePaint();
      }
    } catch (err) {
      console.warn('Error in suspendDoAndResume. Please, use a sheet and a valid function as parameter.', err);
    }
  }
};
